import type { Severity } from "./inspection";

export interface Zone {
  code: string;
  label: string;
  shape: { type: "rect"; x: number; y: number; w: number; h: number } | { type: "circle"; cx: number; cy: number; r: number };
}

/** Top-down car schematic zones (viewBox 0 0 200 388). Codes double as finding vehicleArea. */
export const ZONES: Zone[] = [
  { code: "FRONT_BUMPER", label: "Paragolpes delantero", shape: { type: "rect", x: 60, y: 18, w: 80, h: 26 } },
  { code: "HOOD", label: "Capó", shape: { type: "rect", x: 60, y: 48, w: 80, h: 56 } },
  { code: "FENDER_FL", label: "Aleta delantera izquierda", shape: { type: "rect", x: 34, y: 50, w: 24, h: 54 } },
  { code: "FENDER_FR", label: "Aleta delantera derecha", shape: { type: "rect", x: 142, y: 50, w: 24, h: 54 } },
  { code: "DOOR_FL", label: "Puerta delantera izquierda", shape: { type: "rect", x: 34, y: 118, w: 24, h: 54 } },
  { code: "DOOR_FR", label: "Puerta delantera derecha", shape: { type: "rect", x: 142, y: 118, w: 24, h: 54 } },
  { code: "DOOR_RL", label: "Puerta trasera izquierda", shape: { type: "rect", x: 34, y: 176, w: 24, h: 54 } },
  { code: "DOOR_RR", label: "Puerta trasera derecha", shape: { type: "rect", x: 142, y: 176, w: 24, h: 54 } },
  { code: "ROOF", label: "Techo", shape: { type: "rect", x: 62, y: 140, w: 76, h: 92 } },
  { code: "QUARTER_L", label: "Lateral trasero izquierdo", shape: { type: "rect", x: 34, y: 234, w: 24, h: 56 } },
  { code: "QUARTER_R", label: "Lateral trasero derecho", shape: { type: "rect", x: 142, y: 234, w: 24, h: 56 } },
  { code: "TAILGATE", label: "Portón / maletero", shape: { type: "rect", x: 60, y: 300, w: 80, h: 44 } },
  { code: "REAR_BUMPER", label: "Paragolpes trasero", shape: { type: "rect", x: 60, y: 346, w: 80, h: 26 } },
  { code: "WHEEL_FL", label: "Rueda delantera izquierda", shape: { type: "circle", cx: 24, cy: 96, r: 13 } },
  { code: "WHEEL_FR", label: "Rueda delantera derecha", shape: { type: "circle", cx: 176, cy: 96, r: 13 } },
  { code: "WHEEL_RL", label: "Rueda trasera izquierda", shape: { type: "circle", cx: 24, cy: 262, r: 13 } },
  { code: "WHEEL_RR", label: "Rueda trasera derecha", shape: { type: "circle", cx: 176, cy: 262, r: 13 } },
];

export const ZONE_BY_CODE: Record<string, Zone> = Object.fromEntries(ZONES.map((z) => [z.code, z]));
export const ZONE_CODES = new Set(ZONES.map((z) => z.code));

const SEV_RANK: Record<Severity, number> = { INFO: 0, MINOR: 1, MAJOR: 2, CRITICAL: 3 };
export function worstSeverity(sevs: Severity[]): Severity | null {
  if (sevs.length === 0) return null;
  return sevs.reduce((a, b) => (SEV_RANK[b] > SEV_RANK[a] ? b : a));
}
export function severityFill(sev: Severity | null): { fill: string; stroke: string } {
  if (sev === "CRITICAL" || sev === "MAJOR") return { fill: "#fdecec", stroke: "#d61f27" };
  if (sev === "MINOR" || sev === "INFO") return { fill: "#fff7e8", stroke: "#b45309" };
  return { fill: "#ffffff", stroke: "#d0d5dd" };
}
